
import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { FormConfig } from '../Forms/types'
import { CREATIVE_FIELDS } from 'components/Tasks/CREATIVE_FIELDS'
import { Task } from '../../types'
import { BoxScroller } from 'styles/elements/styleElements'

interface CreativeTaskProps {
  task: Task
}

const CreativeTaskDetails: React.FC<CreativeTaskProps> = ({ task }) => {
  const theme = useTheme()
  const formattedTask = task?.extraFields ? { ...task, ...task?.extraFields } : task
  return (
    <BoxScroller
      sx={{
        overflowY: 'auto',
        p: 1,
      }}
    >
      {/* 1. Get fields for the task type */}
      {task.type && FormConfig[task.type] && (
        <Box mb={3}>
          {/* <Typography
            sx={{
              fontWeight: 'bold',
              color: theme.palette.primary.main,
              mb: 2,
              fontSize: 18,
            }}
          >
            {handleFormatTypesString(task.type)}
          </Typography> */}

          {Object.entries(CREATIVE_FIELDS[formattedTask.type] ?? {})
            .filter(([key]) => formattedTask[key] !== undefined && formattedTask[key] !== '')
            .map(([key, config]: [string, any]) => {
              return (
                <Box
                  key={key}
                  mb={1}
                  sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: 14,
                      color: theme.palette.text.secondary,
                      mb: 0.5,
                      textAlign: 'left',
                    }}
                  >
                    {config.label}
                  </Typography>

                  {Array.isArray(formattedTask[key]) ? (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {formattedTask[key].map((item: string, idx: number) => {
                        return (
                          <Typography
                            key={idx}
                            sx={{
                              border: `1px solid ${theme.palette.text.primary}`,
                              borderRadius: '16px',
                              px: 1,
                              py: 0.5,
                              fontSize: 13,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              maxWidth: 140,
                              textAlign: 'left',
                            }}
                          >
                            {item}
                          </Typography>
                        )
                      })}
                    </Box>
                  ) : key && ['primary_color', 'secondary_color', 'accent_color']?.includes(key) ? (
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: 18, textAlign: 'center', color: theme.palette.primary.contrastText }}
                      >
                        {formattedTask[key]}
                      </Typography>
                      <Box sx={{ backgroundColor: formattedTask[key] ?? '', minHeight: 24, minWidth: 24 }} />
                    </Box>
                  ) : (
                    <Typography variant="body2" sx={{ fontSize: 18, textAlign: 'left' }}>
                      {formattedTask[key]}
                    </Typography>
                  )}
                </Box>
              )
            })}
        </Box>
      )}
    </BoxScroller>
  )
}

export default CreativeTaskDetails
